module.exports = __webpack_public_path__ + "img/binoculars.a4d39563.svg";